import { User } from '@nx-frontend/shared/types';
import { getUserName } from './get-user-name';

/**
 * Get user first letters
 * @param user
 * @returns
 */
export function getUserFirstLetters(user: User) {
  const name = getUserName(user);
  if (name) {
    const [first, last] = name.split(' ');
    if (first && last) {
      return first.charAt(0).toUpperCase() + last.charAt(0).toUpperCase();
    } else {
      return name.substring(0, 2).toUpperCase();
    }
  }
  return user.email.substring(0, 2).toUpperCase();
}
